import { render } from "./Collection.vue?vue&type=template&id=95211cc8&ts=true"
import script from "./Collection.vue?vue&type=script&lang=ts"
export * from "./Collection.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src2791644585/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__